import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonStepper from '../../../components/common-stepper/CommonStepper';

function ContactStepper({ activeStep }) {
  const { t } = useTranslation('contact');

  const STEPS = [t('typeOfRequest'), t('contactInformation'), t('requestDescription')];

  return <CommonStepper activeStep={activeStep} steps={STEPS} />;
}

export default ContactStepper;
